/**
 * SD-2708: the plain-text flavour of the copied email body.
 *
 * The body arrives as Markdown and is rendered for the preview and for the `text/html` flavour, so
 * links become real anchors there. A plain-text target has nowhere to hide an href, and
 * `[the deal room](https://...)` read literally is brackets and parentheses wrapped around a URL —
 * so the same links are flattened to `text (url)` on the way into `text/plain` only.
 *
 * Kept out of the backend deliberately. Flattening there would cost the anchor in both flavours;
 * the two only diverge at the point the clipboard is written.
 */

/**
 * Markdown link syntax, including the optional title Markdown allows and the leading "!" of an
 * image. The link text stops at "]" and the target at whitespace, so a bracketed aside in prose
 * ("[see below]") or a reference-style link ("[text][1]") is left alone.
 */
const MD_LINK = /!?\[([^\]\n]+)\]\((\S+?)(?:\s+"[^"]*")?\)/g;

/** Rewrite Markdown links as `text (url)`, leaving the text alone where it already is the url. */
export function flattenMarkdownLinks(markdown: string): string {
  if (!markdown) return '';
  return markdown.replace(MD_LINK, (_match, text: string, url: string) => {
    const label = text.trim();
    const target = url.trim();
    return label.includes(target) ? label : `${label} (${target})`;
  });
}
